module.exports = __webpack_public_path__ + "img/stars_blank.5f40f6e0.png";